import { z } from "zod";
import { statusUpdateScopeSchema } from "./chat";

export const projectUpdateSchema = z.object({
    id: z.string(),
    projectId: z.string(),
    chatId: z.string(),
    scope: statusUpdateScopeSchema,
    content: z.string(),
    title: z.string(),
    sentAt: z.string(),
});
export type ProjectUpdate = z.infer<typeof projectUpdateSchema>;

export const createSentUpdateInputSchema = z.object({
    chatId: z.string(),
    scope: statusUpdateScopeSchema,
    content: z.string(),
});
export type CreateSentUpdateInput = z.infer<typeof createSentUpdateInputSchema>;
